import React from 'react';

interface Props {
    onDrop: (e: React.DragEvent<HTMLDivElement>) => void;
    className?: string;
}

class DropZone extends React.Component<Props, { background: string }> {

    constructor(props: Props) {
        super(props);

        this.state = {
            background: 'transparent'
        }

        this.onDragOver = this.onDragOver.bind(this);
    }

    onDragOver(e: React.DragEvent<HTMLDivElement>): void {
        this.setState({ background: '#007BFF' });

        e.preventDefault();
    }

    render(): JSX.Element {
        return (
            <div
                style={{ background: this.state.background}}
                className={`${this.state.background} ${this.props.className || ''}`}
                draggable={true}
                onDropCapture={(e)=>this.props.onDrop(e)}
                onDragLeave={() => this.setState({ background: 'transparent' })}
                onDragOver={this.onDragOver}>
            </div>
        );
    }
}

export default DropZone;